export enum CURRENCY_SYMBOLS {
  EUR = '€',
  USD = '$',
}
